module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/modal-close-icon-1-08cecd504198e41c5795855e639e9abe.svg";